"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModelStore = createModelStore;
var models_1 = require("@scrubtech/models");
var reselect_1 = require("reselect");
var actions = __importStar(require("../actions/actions"));
var ModelReducer_1 = require("../reducer/ModelReducer");
var utils_1 = require("../utils/utils");
/**
 * Creates a complete store module for a given model type
 * @param config Configuration for the model store
 * @returns Object containing actions, selectors, reducer, and action types for the model
 */
function createModelStore(config) {
    var _this = this;
    var actionTypePrefix = config.actionTypePrefix, getEntityID = config.getEntityID, stateKey = config.stateKey, entityName = config.entityName, _a = config.successMessages, successMessages = _a === void 0 ? {} : _a, service = config.service, _b = config.customActionHandlers, customActionHandlers = _b === void 0 ? {} : _b, extractEntities = config.extractEntities, navigationConfig = config.navigationConfig;
    // Action Types
    var ACTION_TYPES = {
        FETCH_ALL: "".concat(actionTypePrefix, "_FETCH_ALL"),
        FETCH_BY_ID: "".concat(actionTypePrefix, "_FETCH_BY_ID"),
        CREATE: "".concat(actionTypePrefix, "_CREATE"),
        UPDATE: "".concat(actionTypePrefix, "_UPDATE"),
        DELETE: "".concat(actionTypePrefix, "_DELETE"),
        CLEAR_SELECTED: "".concat(actionTypePrefix, "_CLEAR_SELECTED"),
        CLEAR_ERROR: "".concat(actionTypePrefix, "_CLEAR_ERROR"),
    };
    // Create reducer config
    var reducerConfig = {
        actionTypes: ACTION_TYPES,
        getEntityID: getEntityID,
        entityName: config.entityName,
        extractEntities: extractEntities || (function (response) {
            return response.items || [];
        }),
        service: service || {
            fetchAll: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, ({ items: [], paginationInfo: new models_1.PaginationInfo() })];
            }); }); },
            fetchByID: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, ({})];
            }); }); },
            create: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, ({})];
            }); }); },
            update: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, ({})];
            }); }); },
            delete: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, ({})];
            }); }); },
        },
        navigationConfig: navigationConfig || {
            getPostCreationUrl: function () { return ''; },
            getPostDeletionUrl: function () { return ''; },
        },
        actionCreators: {
            resolveFetchAll: function (response, requestParams) {
                return actions.resolveFetchAll(ACTION_TYPES.FETCH_ALL, response, requestParams);
            },
            rejectFetchAll: function (error, requestParams) {
                return actions.rejectFetchAll(ACTION_TYPES.FETCH_ALL, error, requestParams);
            },
            resolveFetchByID: function (response) {
                return actions.resolveFetchByID(ACTION_TYPES.FETCH_BY_ID, response);
            },
            rejectFetchByID: function (error, id) {
                return actions.rejectFetchByID(ACTION_TYPES.FETCH_BY_ID, error, id);
            },
            resolveCreate: function (response) {
                return actions.resolveCreate(ACTION_TYPES.CREATE, response);
            },
            rejectCreate: function (error, data) {
                return actions.rejectCreate(ACTION_TYPES.CREATE, error, data);
            },
            resolveUpdate: function (response) {
                return actions.resolveUpdate(ACTION_TYPES.UPDATE, response);
            },
            rejectUpdate: function (error, id, data) {
                return actions.rejectUpdate(ACTION_TYPES.UPDATE, error, id, data);
            },
            resolveDelete: function (response) {
                return actions.resolveDelete(ACTION_TYPES.DELETE, response);
            },
            rejectDelete: function (error, id) {
                return actions.rejectDelete(ACTION_TYPES.DELETE, error, id);
            },
        },
        customActionHandlers: customActionHandlers,
    };
    // Create the initial state
    var initialState = {
        byID: {},
        pages: {},
        isFetchingByID: {},
        errorByID: {},
        selectedEntity: null,
        loading: false,
        error: null,
    };
    // Create the reducer
    var reducer = (0, ModelReducer_1.createGenericReducer)(reducerConfig, initialState);
    // Action Creators
    var modelActions = {
        // Fetch all
        fetchAll: function (page, limit, search) {
            return actions.fetchAll(ACTION_TYPES.FETCH_ALL, { page: page, limit: limit, search: search });
        },
        resolveFetchAll: function (response, requestParams) {
            return actions.resolveFetchAll(ACTION_TYPES.FETCH_ALL, response, requestParams);
        },
        rejectFetchAll: function (error, requestParams) {
            return actions.rejectFetchAll(ACTION_TYPES.FETCH_ALL, error, requestParams);
        },
        // Fetch by ID
        fetchByID: function (id) {
            return actions.fetchByID(ACTION_TYPES.FETCH_BY_ID, id);
        },
        resolveFetchByID: function (entity) {
            return actions.resolveFetchByID(ACTION_TYPES.FETCH_BY_ID, entity);
        },
        rejectFetchByID: function (error, id) {
            return actions.rejectFetchByID(ACTION_TYPES.FETCH_BY_ID, error, id);
        },
        // Create
        create: function (data) {
            return actions.create(ACTION_TYPES.CREATE, data);
        },
        resolveCreate: function (entity) {
            return actions.resolveCreate(ACTION_TYPES.CREATE, entity);
        },
        rejectCreate: function (error, data) {
            return actions.rejectCreate(ACTION_TYPES.CREATE, error, data);
        },
        // Update
        update: function (id, data) {
            return actions.update(ACTION_TYPES.UPDATE, id, data);
        },
        resolveUpdate: function (entity) {
            return actions.resolveUpdate(ACTION_TYPES.UPDATE, entity);
        },
        rejectUpdate: function (error, id, data) {
            return actions.rejectUpdate(ACTION_TYPES.UPDATE, error, id, data);
        },
        // Delete
        delete: function (id) {
            return actions.deleteEntity(ACTION_TYPES.DELETE, id);
        },
        resolveDelete: function (entity) {
            return actions.resolveDelete(ACTION_TYPES.DELETE, entity);
        },
        rejectDelete: function (error, id) {
            return actions.rejectDelete(ACTION_TYPES.DELETE, error, id);
        },
        // Utility actions
        clearSelected: function () { return ({ type: ACTION_TYPES.CLEAR_SELECTED }); },
        clearError: function () { return ({ type: ACTION_TYPES.CLEAR_ERROR }); },
    };
    // Base selector
    var selectState = function (state) { return state[stateKey]; };
    // Memoized selectors
    var modelSelectors = {
        selectState: selectState,
        // Select all entities as an array (memoized)
        selectAll: (0, reselect_1.createSelector)(selectState, function (modelState) { return Object.values(modelState.byID || {}); }),
        // Select a specific entity by ID (memoized)
        selectByID: (0, reselect_1.createSelector)([selectState, function (_state, id) { return id; }], function (modelState, id) { return modelState.byID[id]; }),
        // Select an error obtained while fetching by ID (memoized)
        selectErrorByID: (0, reselect_1.createSelector)([selectState, function (_state, id) { return id; }], function (modelState, id) { return modelState.errorByID[id]; }),
        // Select entities for a specific page (memoized)
        selectByPage: (0, reselect_1.createSelector)([selectState, function (_state, query) { return (0, utils_1.generatePageKey)(query); }], function (modelState, pageKey) {
            var page = modelState.pages[pageKey];
            if (!page)
                return [];
            return page.childIDs.map(function (id) { return modelState.byID[id]; }).filter(Boolean);
        }),
        // Select pagination info for a page (memoized)
        selectPaginationInfo: (0, reselect_1.createSelector)([selectState, function (_state, query) { return (0, utils_1.generatePageKey)(query); }], function (modelState, pageKey) { var _a; return ((_a = modelState.pages[pageKey]) === null || _a === void 0 ? void 0 : _a.paginationInfo) || null; }),
        // Select loading states (memoized)
        selectPageIsFetching: (0, reselect_1.createSelector)([selectState, function (_state, query) { return (0, utils_1.generatePageKey)(query); }], function (modelState, pageKey) { var _a; return ((_a = modelState.pages[pageKey]) === null || _a === void 0 ? void 0 : _a.isFetching) || false; }),
        // Select if a page is initialized (memoized)
        selectPageIsInitialized: (0, reselect_1.createSelector)([selectState, function (_state, query) { return (0, utils_1.generatePageKey)(query); }], function (modelState, pageKey) {
            return Boolean(modelState.pages[pageKey]);
        }),
        selectIsFetchingByID: (0, reselect_1.createSelector)([selectState, function (_state, id) { return id; }], function (modelState, id) {
            return modelState.isFetchingByID[id] || false;
        }),
    };
    return {
        reducer: reducer,
        actions: modelActions,
        selectors: modelSelectors,
        actionTypes: ACTION_TYPES,
    };
}
